// const init_shipment = {
//   customer_id: {
//     value: "",
//     label: "Customer",
//     placeholder: "Select customer",
//   },
//   vehicle_id: {
//     value: "",
//     label: "Vehicle",
//     placeholder: "Select vehicle (optional)",
//   },
//   driver_id: {
//     value: "",
//     label: "Driver",
//     placeholder: "Select driver (optional)",
//   },
//   dispatcher_id: {
//     value: "",
//     label: "Dispatcher",
//     placeholder: "Select dispatcher (optional)",
//   },
//   order_date: {
//     value: new Date().toISOString().slice(0, 10),
//     label: "Order Date",
//     placeholder: "Select order date",
//   },
//   origin: {
//     value: "",
//     label: "Origin",
//     placeholder: "Enter origin address",
//   },
//   destination: {
//     value: "",
//     label: "Destination",
//     placeholder: "Enter destination address",
//   },
//   total_price: {
//     value: 0,
//     label: "Total Price",
//     placeholder: "Enter total price",
//   },
//   items: {
//     value: [],
//     label: "Items",
//     placeholder: "Add shipment items",
//   },
// };

// export default init_shipment;

const init_shipment = {
  customer_id: {
    value: "",
    label: "Customer",
    placeholder: "Select customer",
  },

  vehicle_id: {
    value: "",
    label: "Vehicle",
    placeholder: "Select vehicle (optional)",
  },

  driver_id: {
    value: "",
    label: "Driver",
    placeholder: "Select driver (optional)",
  },

  dispatcher_id: {
    value: "",
    label: "Dispatcher",
    placeholder: "Select dispatcher (optional)",
  },

  order_date: {
    value: new Date().toISOString().slice(0, 10),
    label: "Order Date",
    placeholder: "Select order date",
  },

  origin: {
    value: "",
    label: "Origin",
    placeholder: "Enter origin address",
  },

  destination: {
    value: "",
    label: "Destination",
    placeholder: "Enter destination address",
  },

  total_price: {
    value: "", // ✅ MUST be string
    label: "Total Price",
    placeholder: "Enter total price",
  },
};

export default init_shipment;
